module.exports = require("live/components/ui/SearchLoadingOverlay");